import { AxiosBookings } from '../apiConfig'
import { orgId } from '../apiConfig'

const userInfo = {
  orgId: orgId(),
  outletId: null,
  creatorId: orgId(),
}
export const crmApiFactory = {
  $_getAllContacts() {
    const url = `/crm/v1/contact/all/customer/${orgId()}/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_getSingleContact(contactId) {
    const url = `/crm/v1/contact/one/${orgId()}/${orgId()}/${contactId}`
    return AxiosBookings.get(url)
  },
  $_getGraphData() {
    const url = `/crm/v1/contact/graph/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_saveCustomerInformation(payload) {
    const url = '/crm/v1/contact/add'
    return AxiosBookings.post(url, payload)
  },
  $_updateContact(contactId, payload) {
    const url = `/crm/v1/contact/update/${contactId}`
    return AxiosBookings.patch(url, payload)
  },
  $_blacklistContact(payload) {
    // payload.userInfo = { ...userInfo };
    const url = `/crm/v1/contact/suspend`
    return AxiosBookings.patch(url, payload)
  },
  $_getAllBlacklistedContacts() {
    const url = `/crm/v1/contact/suspended/all/customer/${orgId()}/{{creatorId}}`
    return AxiosBookings.get(url)
  },
  $_downloadContact() {
    const url = `/crm/v1/contact/download/customer/${orgId()}/{{outletId}}/{{creatorId}}`
    return AxiosBookings.get(url, {
      responseType: 'blob',
    })
  },
  $_importContact(payload) {
    const url = `/crm/v1/contact/upload/supplier/${orgId()}`
    return AxiosBookings.post(url, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  $_createLoyaltyScheme(payload) {
    const url = '/crm/v1/loyalty-scheme/save'
    return AxiosBookings.post(url, payload)
  },
  $_getAllLoyaltySchemes() {
    const url = `/crm/v1/loyalty-scheme/all/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_deleteLoyaltyScheme(loyaltySchemeId) {
    const url = `/crm/v1/loyalty-scheme/${loyaltySchemeId}`
    let payload = {
      userInfo: {
        ...userInfo,
      },
    }
    return AxiosBookings.delete(url, { data: payload })
  },
  $_addToLoyaltyScheme(payload) {
    const url = '/crm/v1/loyalty-scheme/set'
    return AxiosBookings.post(url, payload)
  },
  $_getContactsCount() {
    const url = `/crm/v1/contact/total/organization/${orgId()}/creator/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_addAccountManager(payload) {
    const url = `/crm/v1/contact/accountmanager/${orgId()}`
    return AxiosBookings.post(url, payload)
  },
  $_getAccountManagers() {
    const url = `/crm/v1/contact/accountmanager/${orgId()}`
    return AxiosBookings.get(url)
  },
  // Pipeline management
  $_getAllLeads() {
    const url = `/crm/v1/pipeline/all/category/lead/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_getAllOpportunities() {
    const url = `/crm/v1/pipeline/all/category/opportunity/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_getAllSales() {
    const url = `/crm/v1/pipeline/all/category/sale/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_getCountsByCategory() {
    const url = `/crm/v1/pipeline/count/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_getMovementOptions() {
    const url = '/crm/v1/pipeline/setting/default'
    return AxiosBookings.get(url)
  },
  $_getPipelineSettings() {
    const url = `/crm/v1/pipeline/setting/get/${orgId()}/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_updatePipelineSettings(payload) {
    const url = '/crm/v1/pipeline/setting/manage'
    return AxiosBookings.post(url, payload)
  },
  $_updateContactStatus(payload) {
    const url = `/crm/v1/pipeline/status/${payload.payload.id}`
    return AxiosBookings.patch(url, payload)
  },
  $_moveLeadToOpportunity(payload) {
    const url = '/crm/v1/pipeline/move/manually'
    return AxiosBookings.post(url, payload)
  },

  // Meetings
  $_scheduleMeeting(payload) {
    const url = '/crm/v1/meetings'
    payload.userInfo = { ...userInfo }
    return AxiosBookings.post(url, payload)
  },
  $_getAllMeetings() {
    const url = `/crm/v1/meetings/organization/${orgId()}/creator/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_getSingleMeeting(meetingId) {
    const url = `/crm/v1/meetings/${meetingId}`
    return AxiosBookings.get(url)
  },
  $_updateMeetingSchedule(meetingId, payload) {
    payload.userInfo = { ...userInfo }

    const url = `/crm/v1/meetings/${meetingId}`
    return AxiosBookings.patch(url, payload)
  },
  $_deleteMeeting(meetingId) {
    const url = `/crm/v1/meetings/${meetingId}`
    return AxiosBookings.delete(url)
  },

  // Settings
  $_getContactSettings() {
    const url = `/crm/v1/settings/customer-type-setting/${orgId()}/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_createContactSettings() {
    // const url = "/crm/v1/settings/customer-type-setting";
    // payload.userInfo = { ...userInfo };
    // return AxiosBookings.post(url, payload);
  },
  $_updateContactSettings(payload) {
    const url = '/crm/v1/settings/customer-type-setting'
    payload.userInfo = { ...userInfo }
    return AxiosBookings.patch(url, payload)
  },
  $_getPriceReferenceSettings() {
    const url = `/crm/v1/settings/price-preference-setting/${orgId()}/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_updatePriceReferenceSettings(payload) {
    payload.userInfo = { ...userInfo }
    const url = `/crm/v1/settings/price-preference-setting`
    return AxiosBookings.patch(url, payload)
  },
  $_getIndustryAndProductSettings() {
    const url = `/crm/v1/settings/product-of-interest-setting/${orgId()}/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_updateIndustryAndProductSettings(payload) {
    payload.userInfo = { ...userInfo }
    const url = `/crm/v1/settings/product-of-interest-setting`
    return AxiosBookings.patch(url, payload)
  },
  $_getLeadStatusSettings() {
    return AxiosBookings.get(`/crm/v1/settings/lead-status/${orgId()}`)
  },
  $_updateLeadStatus(payload) {
    payload.userInfo = { ...userInfo }
    const url = `/crm/v1/settings/lead-status/${orgId()}`
    return AxiosBookings.patch(url, payload)
  },

  // Create promotion
  $_getAllPromotions() {
    const url = `/crm/v1/promotion/${orgId()}`
    return AxiosBookings.get(url)
  },
  $_filterPromotionsByDate(filter) {
    const url = `/crm/v1/promotion/org/${orgId()}/filter/?startDate=${
      filter.startDate
    }T00:00:12.333Z&endDate=${filter.endDate}T23:59:12.333Z`
    return AxiosBookings.get(url)
  },
  $_createPromotion(payload) {
    payload.userInfo = { ...userInfo }
    const url = '/crm/v1/promotion/create'
    return AxiosBookings.post(url, payload)
  },
  $_updatePromotion(promotionId, payload) {
    payload.userInfo = { ...userInfo }

    const url = `/crm/v1/promotion/${orgId()}/${promotionId}`
    return AxiosBookings.patch(url, payload)
  },
  $_deletePromotion(promotionId) {
    const url = `/crm/v1/promotion/${orgId()}/${promotionId}`
    return AxiosBookings.delete(url)
  },
  $_getPromotionDetails(promotionId) {
    const url = `/crm/v1/promotion/${orgId()}/${promotionId}`
    return AxiosBookings.get(url)
  },
}
